import { ref } from 'vue';
import {
  countryCodeIsVietnam,
  peekCachedCurrentIpCountryCode,
  resolveCountryCodeFromCurrentIp,
} from '@/utils/ip-country-lookup';

/**
 * 落地「现金扫码」仅当前出口 IP 为 VN 时展示。
 * 资料国家码不参与；探测失败 fail-closed（不展示）。
 */
export const VIETNAM_PAY_IP_GUARD_ENABLED = true;

export const vietnamPayIpAllowed = ref(
  !VIETNAM_PAY_IP_GUARD_ENABLED || countryCodeIsVietnam(peekCachedCurrentIpCountryCode())
);

export function resetVietnamPayIpAllowed() {
  vietnamPayIpAllowed.value = !VIETNAM_PAY_IP_GUARD_ENABLED;
}

/**
 * 仅看当前出口网络。打开弹窗时跟在美国 IP 探测之后调用即可复用缓存。
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
export async function resolveIsVietnamPayIpAllowed({ forceRefresh = false } = {}) {
  if (!VIETNAM_PAY_IP_GUARD_ENABLED) {
    vietnamPayIpAllowed.value = true;
    return true;
  }
  const countryCode = await resolveCountryCodeFromCurrentIp({ forceRefresh }).catch(() => null);
  const allowed = countryCodeIsVietnam(countryCode);
  vietnamPayIpAllowed.value = allowed;
  return allowed;
}
